import { render, staticRenderFns } from "./EditOtherLinks.vue?vue&type=template&id=9f53012e&scoped=true&"
import script from "./EditOtherLinks.vue?vue&type=script&lang=ts&"
export * from "./EditOtherLinks.vue?vue&type=script&lang=ts&"
import style0 from "./EditOtherLinks.vue?vue&type=style&index=0&id=9f53012e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f53012e",
  null
  
)

export default component.exports